import { z } from 'zod';

/////////////////////////////////////////
// CORE ADDRESS SCHEMA
/////////////////////////////////////////

export const CoreAddressSchema = z.object({
  id: z.number().int(),
  attn: z.string().nullable(),
  address: z.string(),
  address2: z.string().nullable(),
  city: z.string(),
  state: z.string(),
  zip: z.string(),
  rowTimestamp: z.coerce.date(),
  countryId: z.string(),
})

export type CoreAddress = z.infer<typeof CoreAddressSchema>

export default CoreAddressSchema;
